/*  A Vuex module. 
*   Userstore to store common userdata for current user and further
*/
const state = {
    crm : null
};

const mutations = {
    crm: (state, val) => {
        state.crm = val;
    },
};

const actions = {
    crm: ({ commit }, val) => {
        commit("crm", val);
    },
};

const getters = {
    crm: (state) => {
        return state.crm;
    },
    state: (state) => {
        return {
            crm: state.crm,
        };
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};